"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const AlertOptionsLabel = ({ alertOptions }) => {
    const displayText = {
        systemNotification: 'push notification',
        notificationCenter: 'notification center',
        badgeNumber: 'badge number',
    };
    const activatedAlerts = Object.keys(alertOptions)
        .filter((k) => alertOptions[k])
        .map((j) => displayText[j]);
    const stringArr = activatedAlerts.join(', ');
    const lastComma = stringArr.lastIndexOf(',');
    let displayStr = stringArr.substr(0, lastComma) + (activatedAlerts.length > 1 ? ' and ' : '') + stringArr.substr(lastComma + 1);
    displayStr = displayStr.length > 0 ? displayStr[0].toUpperCase() + displayStr.slice(1) : '';
    return (React.createElement(src_1.Text, { text: displayStr, size: "small", textStyle: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        } }));
};
exports.default = AlertOptionsLabel;
